import { render } from "./ExaminableTasksModal.vue?vue&type=template&id=8f475aee"
import script from "./ExaminableTasksModal.vue?vue&type=script&lang=js"
export * from "./ExaminableTasksModal.vue?vue&type=script&lang=js"

import "./ExaminableTasksModal.vue?vue&type=style&index=0&id=8f475aee&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__